import { EmployeePaymentMethodType } from '@zorro/clients';

type PlanPaymentAmounts = {
  premium: number;
  selfPayAmount?: number | null;
};

export const mapPlanToPaymentMethodType = ({
  premium,
  selfPayAmount,
}: PlanPaymentAmounts): EmployeePaymentMethodType => {
  if (!selfPayAmount) {
    return EmployeePaymentMethodType.ZORRO_PAY;
  }

  if (selfPayAmount === premium) {
    return EmployeePaymentMethodType.SELF_PAY;
  }

  if (selfPayAmount > 0 && selfPayAmount < premium) {
    return EmployeePaymentMethodType.COMBINED;
  }

  return EmployeePaymentMethodType.ZORRO_PAY;
};
